import React from 'react';
import { Link } from 'react-router-dom';
import HelpApiLayout from '../../../components/layout/HelpApiLayout';
import ApiSidebar from '../../../components/layout/ApiSidebar';
import { PUBLIC_ROUTES } from '../../../constants/routes';
import { getApiDocsRoute } from '../../../utils/navigation';
import './ApiDocsPage.css';

/**
 * Wallets API Documentation Page
 */
const Wallets = () => {
  return (
    <HelpApiLayout type="api" sidebar={<ApiSidebar />}>
      <div className="api-docs-page">
        <div className="api-docs-page-container">
          <main className="api-docs-main">
            <header className="api-docs-page-header">
              <h1 className="lp-section-title">Wallets API</h1>
              <p className="lp-section-subtitle">
                Wallet management endpoints are currently under development and will be available in a future release.
              </p>
            </header>

            <section className="api-docs-page-section">
              <div className="endpoint-unavailable-notice">
                <h2>Wallets API</h2>
                <p><strong>Status:</strong> Coming Soon</p>
                <p>The Wallets API endpoints are currently under development and will be available in a future release.</p>
                <p>For now, wallet-related operations are handled through the <Link to={getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_SPLITS)}>Splits API</Link> endpoints.</p>
              </div>
            </section>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Wallets;
